import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button } from 'primereact/button';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import PacientePedidoPadrao from './components/InformacoesPaciente/PacientePedidoPadrao';
import PacientePedidoSaudeSuplementar from './components/InformacoesPaciente/PacientePedidoSaudeSuplementar';
import { PendenciasWizard } from './ValidacaoWizard';
import 'assets/css/geral.css';
import 'assets/css/informacoes-paciente.css';

const tipoPedidoPadrao = 0;
const tipoPedidoSuplementar = 1;

class InformacoesPaciente extends Component {
  state = {
    tipoPedidoSelecionado: 0,
  };

  trocarTipo = tipo => {
    this.setState({ tipoPedidoSelecionado: tipo });
    localStorage.setItem('tipoPedido', tipo);

    if (tipo === tipoPedidoPadrao) {
      localStorage.removeItem('novoPaciente');

      localStorage.setItem(
        'pendenciasNovoPacienteSuplementar',
        JSON.stringify([
          PendenciasWizard.novoPacienteNome,
          PendenciasWizard.novoPacienteDataNascimento,
          PendenciasWizard.novoPacienteSexo,
          PendenciasWizard.novoPacienteNomeMae,
          PendenciasWizard.novoPacienteCPF,
        ])
      );
    }
  };

  render() {
    return (
      <Container>
        <div>
          <Button
            label="Pedido Padrão"
            onClick={() => this.trocarTipo(tipoPedidoPadrao)}
            className={
              this.state.tipoPedidoSelecionado === tipoPedidoPadrao
                ? ''
                : 'botao-filtro-desabilitado'
            }
          />
          <Button
            label="Pedido de Saúde Suplementar"
            onClick={() => this.trocarTipo(tipoPedidoSuplementar)}
            className={
              this.state.tipoPedidoSelecionado === tipoPedidoSuplementar
                ? ''
                : 'botao-filtro-desabilitado'
            }
          />
        </div>
        <Divider />
        <br />
        <Grid container spacing={2}>
          {this.state.tipoPedidoSelecionado === tipoPedidoPadrao ? (
            <PacientePedidoPadrao />
          ) : (
            <PacientePedidoSaudeSuplementar />
          )}
        </Grid>
      </Container>
    );
  }
}

export default InformacoesPaciente;
